import { Map, Pin } from "themes/module_map/static/js/map";
import { SiteConfig } from "static/js/app/hugoSettings/siteConfig";
import { PageConfig } from "static/js/app/hugoSettings/PageConfig";

export default class ContactPage {
    public static init(siteConfig: SiteConfig, pageConfig: PageConfig) {
        Map.initializeBranchesMap(siteConfig.map, "mapContact", siteConfig.dealerBranches);
    }
}
